var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "waves",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 24 150 28",
    preserveAspectRatio: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "gentle-wave",
    d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "parallax"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 0,
    fill: "rgb(110,42,139,0.7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 3,
    fill: "rgb(110,42,139,0.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 5,
    fill: "rgb(113,85,181,0.3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 7,
    fill: "rgb(113,85,181)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.c006c119a6f5778c90ffb4302d3d0f7c.svg";
export { ForwardRef as ReactComponent };